import {Input} from "../../../basic/input";
import {Label} from "../../../basic/label";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";

interface LicenseFormProps {
    quantity: number;
    expiration: string;
    onQuantityChange: (quantity: number) => void;
    onExpirationChange: (expiration: string) => void;
}

export function LicenseForm({quantity, expiration, onQuantityChange, onExpirationChange}: LicenseFormProps) {
    const {t} = useTranslationWithKeys();

    return (
        <>
            <div className="space-y-2">
                <Label htmlFor="quantity">{t('admin.licenses.createLicenseDialog.numberOfSeats')} *</Label>
                <Input
                    id="quantity"
                    type="number"
                    min="1"
                    value={quantity}
                    onChange={(e) => {
                        const value = parseInt(e.target.value);
                        if (!isNaN(value) && value >= 1) {
                            onQuantityChange(value);
                        }
                    }}
                    placeholder={t('admin.licenses.createLicenseDialog.enterNumberOfSeats')}
                />
            </div>

            <div className="space-y-2">
                <Label
                    htmlFor="expiration">{t('admin.licenses.createLicenseDialog.expirationDate')} ({t('common.optional')})</Label>
                <Input
                    id="expiration"
                    type="date"
                    value={expiration}
                    onChange={(e) => onExpirationChange(e.target.value)}
                    min={new Date().toISOString().split('T')[0]}
                />
            </div>
        </>
    );
}